
<script setup>
import { ref, defineProps, defineEmits, onMounted, onBeforeUnmount } from 'vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps({
  title: { type: String, required: true },
  value: { type: String, default: '' },
  autoUseFirst: { type: Boolean, required: true },
})
const emits = defineEmits(['update', 'updateAutoUseFirst'])
const focusRef = ref(null)
const localValue = ref(props.value)

onMounted(() => focusRef.value.innerRef.focus())
onBeforeUnmount(() => emits('update', localValue.value))
</script>

<template>
  <div class="bg-modal" style="width: 30vw;">
    <text-item :txt="props.title" class="mleft-04" styles="font-l main-h"/>
    <div class="row w-full">
      <switchGroup :active="props.autoUseFirst" @click="emits('updateAutoUseFirst', !props.autoUseFirst)" class="mleft-auto">
        <text-item :txt="t('patient.pharmacy.prescriptionInfo.autoUseFirst')" :class="props.autoUseFirst ? 'img-white' : ''"/>
      </switchGroup>
    </div>


    <inputBox class="mtop-04">
      <inputAreaAuto2 ref="focusRef" :lines=10 v-model="localValue" @blur="emits('update', localValue)"/>
    </inputBox>
  </div>
</template>
